import {createSelector} from 'reselect';

import {getContactsManagerSidePanelState} from '../contactsManagerPanelSelectors';
import {sidePanelIsMergeContactsForm} from './contactsManagerSidePanelState';

/*
 * Selectors.
 */

export function makeGetMergeContactsSidePanelState() {
  return createSelector([getContactsManagerSidePanelState], (sidePanelState) => {
    if (!sidePanelIsMergeContactsForm(sidePanelState)) {
      return undefined;
    }
    return sidePanelState;
  });
}

export function makeGetMergeContactsSidePanelStatus() {
  return createSelector([getContactsManagerSidePanelState], (sidePanelState) => {
    if (!sidePanelIsMergeContactsForm(sidePanelState)) {
      return undefined;
    }
    return sidePanelState.status;
  });
}
